/*
 * Forsidens hero-video hentes kun naar det giver mening.
 *
 * Videoen er en 1920x1080 MP4 paa knap 10 MB. Den blev hentet i fuld
 * stoerrelse ogsaa paa telefoner, hvor den er 40 gange tungere end alt andet
 * paa siden tilsammen. Kilden ligger derfor i data-nt-src, og vi saetter den
 * foerst naar:
 *
 *   - skaermen er bred nok (eller sektionen har "afspil ogsaa paa mobil"),
 *   - brugeren ikke har bedt om mindre bevaegelse,
 *   - browseren ikke er i datasparetilstand.
 *
 * Uden src viser <video> sit poster-billede, saa heroen ser ens ud.
 */
(function () {
  'use strict';

  function maaHente(video) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;

    var forb = navigator.connection;
    if (forb && forb.saveData) return false;
    /* 2g/3g: en 10 MB video er minutter, ikke sekunder */
    if (forb && /(^|-)2g$/.test(forb.effectiveType || '')) return false;

    return true;
  }

  /* Hvilken kilde: den lette til mobil hvis der er lagt en ind, ellers den
     almindelige. Er der ingen mobil-udgave, henter vi slet ikke noget paa
     telefoner, og plakatbilledet bliver staaende. */
  function kildeTil(video, kilde) {
    if (window.matchMedia('(min-width: 769px)').matches) return kilde.dataset.ntSrc;
    if (kilde.dataset.ntSrcMobil) return kilde.dataset.ntSrcMobil;
    if (video.dataset.ntMobil === 'true') return kilde.dataset.ntSrc;
    return null;
  }

  function start() {
    document.querySelectorAll('video.nt-hero-video').forEach(function (video) {
      var kilde = video.querySelector('source[data-nt-src]');
      if (!kilde) return;
      /* Kun én gang pr. element. Observeren fyrer flere gange, og et nyt
         load() midt i et play() giver "The play() request was interrupted". */
      if (kilde.getAttribute('src')) return;
      if (!maaHente(video)) return;

      var url = kildeTil(video, kilde);
      if (!url) return;

      kilde.src = url;
      video.preload = 'metadata';
      video.muted = true;          /* iOS afspiller kun lydloest af sig selv */
      video.setAttribute('muted', '');
      video.playsInline = true;
      video.autoplay = true;
      video.load();

      /* play() SKAL kaldes. iOS starter ikke af sig selv naar autoplay
         saettes fra JavaScript efter indlaesning, og resultatet var en
         afspil-knap midt paa heroen (Nicolai 12/9).
         Loefterne fanges begge steder, saa den uskadelige advarsel
         "The play() request was interrupted by a new load request" ikke
         ender som en ufanget fejl. Den kommer fra temaets eget
         <video-component>, som naar at kalde play() paa det tomme element
         foer vi saetter kilden. */
      var start = function () {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      };
      if (video.readyState >= 2) {
        start();
      } else {
        video.addEventListener('loadeddata', start, { once: true });
        video.addEventListener('canplay', start, { once: true });
      }
    });
  }

  /* <video-component> er et custom element fra temaet, og det bygger sit
     indhold om naar det opgraderes. Saetter vi src foer det sker, bliver den
     tabt. Derfor koerer vi flere gange og holder oeje med nye kilder. */
  function koer() {
    start();
  }

  /* Ét kald, og det skal vaere ved load.
     DOMContentLoaded er for tidligt: temaets <video-component> bygger sit
     indhold om bagefter, og saa er src'en tabt igen.
     Begge dele gav "The play() request was interrupted", fordi komponenten
     naaede at starte afspilningen mellem de to kald. */
  if (document.readyState === 'complete') {
    koer();
  } else {
    window.addEventListener('load', koer, { once: true });
  }

  /* Ingen MutationObserver: den fangede kilden igen efter at temaets
     <video-component> var begyndt at afspille, og et load() dér gav
     "The play() request was interrupted". DOMContentLoaded plus load er nok,
     maalt paa baade mobil og desktop. */
})();
